import { Component} from '@angular/core';
import { AutoLogoutService } from './services/auth/authlogout.service';
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(
    private autoLogout: AutoLogoutService
  ){}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts